import React from 'react'

import find from 'lodash/find'
import union from 'lodash/union'
import without from 'lodash/without'
import filter from 'lodash/filter'
import clamp from 'lodash/clamp'
import last from 'lodash/last'

import { Option, Pill } from '../multi-select/multi-select-parts'

class ServicingLabelSelector extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedRow: null,
      search: '',
      visibleOptions: props.options || [],
    }
  }

  componentDidMount () {
    this.focusSearch()
  }

  onInputChange (search) {
    this.setState({ search })
  }

  focusSearch () {
    this.refs.search.focus()
  }

  getOptionForValue (value) {
    return find(this.props.options, { value })
  }

  isSelected (value) {
    return (this.props.value || []).includes(value)
  }

  toggleValue (value) {
    const initialValue = this.props.value || []
    let newValue

    if (this.isSelected(value)) {
      newValue = without(initialValue, value)
    } else {
      if (this.refs.search.value) {
        this.refs.search.value = ''
        this.onInputChange('')
      }

      newValue = union(initialValue, [value])
    }

    this.props.onChange(newValue)
    this.focusSearch()
  }

  onKeyDown (event) {
    const currentRow = this.state.selectedRow
    let newRow

    switch (event.keyCode) {
      case 38:
        newRow = currentRow === null ? 0 : currentRow - 1
        this.setSelectedRow(newRow)
        break
      case 40:
        newRow = currentRow === null ? 0 : currentRow + 1
        this.setSelectedRow(newRow)
        break
      case 8:
        if (!this.refs.search.value) {
          event.preventDefault()
          this.undoLastOption()
        }
        break
      case 13:
        currentRow !== null && this.toggleValue(this.props.searchableValues[currentRow])
        break
    }
  }

  setSelectedRow (row) {
    if (row === null) {
      this.setState({ selectedRow: null })
      return
    }

    const max = this.props.options.length - 1

    this.setState({
      selectedRow: clamp(row, 0, max)
    })
  }

  undoLastOption () {
    if (this.props.value.length === 0) return

    const lastOption = this.getOptionForValue(last(this.props.value))

    this.onInputChange(lastOption.label)
    this.refs.search.value = lastOption.label
    this.toggleValue(lastOption.value)
  }

  getVisibleOptions (search) {
    const regex = new RegExp(search, 'i')

    return filter(this.props.options, (option) => {
      return option.label.match(regex)
    })
  }

  pillForOption (option) {
    if (!option) return <Pill label="Loading..." />

    return (
      <Pill
        label={option.label}
        key={option.value}
        onClose={() => this.toggleValue(option.value)}
      />
    )
  }

  render () {
    const { value = [] } = this.props
    const visibleOptions = this.getVisibleOptions(this.state.search)

    const visibleOptionRows = visibleOptions.map(({value, label}, i) => {
      const optionValues = {
        key: value,
        selected: this.isSelected(value),
        hovered: i === this.state.selectedRow,
        onMouseOver: () => this.setSelectedRow(i),
        onMouseOut: () => this.setSelectedRow(null),
        onToggle: () => this.toggleValue(value),
        label: label
      }

      return (<Option {...optionValues} />)
    })

    return (
      <div className="area-selector">
        <div className="search" onClick={() => this.focusSearch}>
          <div className="faux-search-field">
            {(value || []).map((value) => {
              const option = this.getOptionForValue(value)

              return this.pillForOption(option)
            })}

            <input
              type="search"
              ref="search"
              onChange={(e) => this.onInputChange(e.target.value)}
              onKeyDown={(e) => this.onKeyDown(e)}
            />
          </div>
        </div>

        <div className="list-view" ref="list">
          <div ref="listContainer">
            {visibleOptionRows}
          </div>
        </div>
      </div>
    )
  }
}

export default ServicingLabelSelector



// WEBPACK FOOTER //
// ./src/components/servicing-labels/servicing-label-selector.js